module.exports = __webpack_public_path__ + "static/media/Raleway-ExtraBold.27f7ef17.ttf";